<template>
  <tr
    class="text-body group/row hover:bg-beige-0 border-beige-10 text-grey-1 group transition-background relative h-0 border-t border-solid duration-300 ease-in-out"
  >
    <td class="px-4! py-2!">
      <RfColorTag pill disabled :backgroundColor="props.color" :title="props.title" />
    </td>
    <td class="text-black-1! px-4! py-2!">
      {{ props.creator }}
    </td>
    <td class="text-black-1! px-4! py-2!">{{ props.description }}</td>
    <td class="w-20 px-4! py-2!">
      <div class="flex items-center justify-center">
        <RfColorTag class="h-6 w-6 grow-0" disabled :backgroundColor="getTagColor(props.color)" />
      </div>
    </td>
    <td class="w-6 px-0! py-0!">
      <div
        class="items-center justify-center opacity-0 transition-opacity duration-200 group-hover/row:opacity-100!"
      >
        <RfButtonNew
          type="plain"
          size="none"
          class="px-2! py-2!"
          :disabled="props.disabled"
          @click="emit('edit')"
        >
          <RfEditIcon class="h-6! w-6!" />
        </RfButtonNew>
      </div>
    </td>
    <td class="w-6 px-0! py-0!">
      <div
        class="items-center justify-center opacity-0 transition-opacity duration-200 group-hover/row:opacity-100!"
      >
        <RfButtonNew
          type="plain"
          size="none"
          class="px-2! py-2!"
          :disabled="props.disabled"
          @click="emit('delete')"
        >
          <RfDeleteIcon class="h-6! w-6!" />
        </RfButtonNew>
      </div>
    </td>
  </tr>
</template>

<script setup>
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfDeleteIcon from "@/components/icons/RfDeleteIcon.vue";
import RfEditIcon from "@/components/icons/RfEditIcon.vue";
import RfColorTag from "@/components/tags/RfColorTag.vue";
import { tagsColors, getTagColor } from "@/utils/constants/ColorsConstants";

const props = defineProps({
  title: { type: String, default: "Unnamed tag" },
  color: { type: String, default: tagsColors[0] },
  description: { type: String, default: "" },
  creator: { type: String, default: "Recurly" },
  currApp: { type: Object, default: null },
});

const emit = defineEmits(["delete", "edit"]);
</script>
